"use strict";
exports.__esModule = true;
exports.getBaseUrl = exports.PRODUCTION_URL = exports.STAGING_URL = exports.LOCAL_HOST_URL = void 0;
var lib_environment_1 = require("@doordash/lib-environment");
exports.LOCAL_HOST_URL = 'http://localhost:8081';
exports.STAGING_URL = 'https://api.doorcrawl.com';
exports.PRODUCTION_URL = 'https://api.doordash.com';
/**
 * Returns the correct URL for the endpoint based on environment.
 * For local development, requests are proxied by webpack dev server.
 */
exports.getBaseUrl = function (proxyOverride) {
    var environment = lib_environment_1.getDSJEnvironment();
    if (typeof proxyOverride === 'object') {
        var env = environment;
        var override = proxyOverride[env];
        var envInOverrides = Object.keys(proxyOverride).includes(env);
        var baseUrl = override && override.baseUrl;
        var apiProxy = override && override.apiProxy;
        if (envInOverrides) {
            switch (environment) {
                case lib_environment_1.ENVIRONMENTS.PRODUCTION:
                    return (baseUrl || exports.PRODUCTION_URL) + "/" + (apiProxy || '');
                case lib_environment_1.ENVIRONMENTS.STAGING:
                    return (baseUrl || exports.STAGING_URL) + "/" + (apiProxy || '');
                case lib_environment_1.ENVIRONMENTS.LOCAL:
                    return (baseUrl || exports.LOCAL_HOST_URL) + "/" + (apiProxy || 'api');
                // Intentionally left no default to allow fall through to next switch
            }
        }
    }
    switch (environment) {
        case lib_environment_1.ENVIRONMENTS.PRODUCTION:
            return exports.PRODUCTION_URL;
        case lib_environment_1.ENVIRONMENTS.STAGING:
            return exports.STAGING_URL;
        case lib_environment_1.ENVIRONMENTS.LOCAL:
        default:
            return exports.LOCAL_HOST_URL + "/api";
    }
};
